import React, {useState, useEffect} from "react";
import "../css/dropzone.css"
import {Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Snackbar, Alert} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {authorizedFetch} from "../utils/authorizedFetch";
import {useAuth} from "../utils/useAuth";

export default function LooksForm({selectedEvent, onSuccess}) {
    const {getAccessToken} = useAuth();
    const [formData, setFormData] = useState({
        look: [
            {
                type: "main",
                collection: "",
                name: "",
                file: null,
            },
        ],
    });
    const [initialData, setInitialData] = useState({look: []});
    const [state, setState] = useState({
        openSuccess: false,
        openError: false,
        vertical: 'top',
        horizontal: 'right',
        successMessage: '',
        errorMessage: ''
    });

    useEffect(() => {
        if (selectedEvent) {
            fetchLooks();
        }
    }, [selectedEvent, getAccessToken]);

    const fetchLooks = async () => {
        try {
            const accessToken = await getAccessToken();
            const data = await authorizedFetch(`${process.env.REACT_APP_API_ENDPOINT}look/import?eventID=${selectedEvent.id}`, {}, accessToken);
            if (data.looks.length > 0) {
                setFormData(prev => ({
                    ...prev,
                    look: data.looks
                }));
                setInitialData({look: data.looks});
            }

        } catch (error) {
            console.error('Error fetching looks:', error);
        }
    };

    const updateLook = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            look: prev.look.map((item, i) =>
                i === index ? {...item, [field]: value} : item
            ),
        }));
    };

    const handleCloseAlert = () => {
        setState({...state, openSuccess: false, openError: false});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = [];

        try {
            const accessToken = await getAccessToken();

            const submitFormData = {
                looks: formData.look.map(currentLook => ({
                    ...currentLook,
                    deleted: false
                }))
            };

            const deletedLooks = [];
            initialData.look.forEach(initialLook => {
                const stillExists = formData.look.some(l => l.name === initialLook.name);
                if (!stillExists) {
                    submitFormData.looks.push({
                        ...initialLook,
                        deleted: true
                    });
                    deletedLooks.push(initialLook);
                }
            });

            const allLooks = [...formData.look, ...deletedLooks];

            for (let i = 0; i < allLooks.length; i++) {
                const look = allLooks[i];
                const isDeleted = deletedLooks.some(dl => dl.name === look.name);

                if (look.file || isDeleted) {
                    try {
                        const deleteParam = isDeleted ? '&deleted=true' : '';

                        if (look.file) {
                            const fileFormData = new FormData();
                            fileFormData.append('file', look.file);
                            fileFormData.append('eventID', selectedEvent.id);
                            fileFormData.append('collection', look.collection);
                            fileFormData.append('name', look.name);

                            await authorizedFetch(`${process.env.REACT_APP_API_ENDPOINT}look/import?eventID=${selectedEvent.id}&collection=${look.name}`, {
                                    method: 'POST',
                                    body: fileFormData,
                                },
                                accessToken);
                        } else if (isDeleted) {
                            await authorizedFetch(`${process.env.REACT_APP_API_ENDPOINT}look/import?eventID=${selectedEvent.id}&collection=${look.name}${deleteParam}`, {
                                    method: 'POST',
                                },
                                accessToken);
                        }
                    } catch (error) {
                        const errorMsg = error.data?.message + ' ' + error.data?.details.missingColumns.toString().replaceAll(',', ', ');
                        errors.push(`Error processing look: ${errorMsg}`);
                    }
                }
            }

            if (errors.length > 0) {
                setState({...state, openError: true, errorMessage: errors.join(', ')});
            } else {
                setState({...state, openSuccess: true, successMessage: 'Looks updated successfully'});
                onSuccess?.();
                await fetchLooks();
            }
        } catch (error) {
            setState({...state, openError: true, errorMessage: error.data?.message});
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    {formData.look.map((item, index) => (
                        <Grid item xs={12} key={index}>
                            <Grid container spacing={2} alignItems="center">

                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                        <InputLabel>Type</InputLabel>
                                        <Select
                                            disabled={true}
                                            className='gucci_text event_select_filter'
                                            value={item.type}
                                            onChange={(e) =>
                                                updateLook(index, "type", e.target.value)
                                            }
                                        >
                                            {index === 0 && <MenuItem value="main">Main</MenuItem>}
                                            <MenuItem value="collection_look">Collection Look</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item xs={3}>
                                    {index > 0 && (
                                        <TextField
                                            fullWidth
                                            label="Descrizione"
                                            value={item.name}
                                            onChange={(e) =>
                                                updateLook(index, "name", e.target.value)
                                            }
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={6}>
                                    <Box display="flex" alignItems="center" gap={1}>

                                        <Box
                                            flex={1}
                                            className="dropzone"
                                            onClick={() =>
                                                document
                                                    .getElementById(`fileInput-${index}`)
                                                    ?.click()
                                            }
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={(e) => {
                                                e.preventDefault();

                                                const file = e.dataTransfer.files[0];
                                                if (file) {
                                                    updateLook(index, "file", file);
                                                }
                                            }}
                                        >
                                            <Button
                                                className="gucci_text"
                                                variant="outlined"
                                            >
                                                {item.file
                                                    ? item.file.name
                                                    : "Select file or drop here"}
                                            </Button>

                                            <input
                                                id={`fileInput-${index}`}
                                                hidden
                                                type="file"
                                                accept=".xls,.xlsx"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0];
                                                    if (file) {
                                                        updateLook(index, "file", file);
                                                    }
                                                }}
                                            />
                                        </Box>

                                        <IconButton
                                            color="primary"
                                            onClick={() =>
                                                setFormData(prev => ({
                                                    ...prev,
                                                    look: [
                                                        ...prev.look,
                                                        {
                                                            id: "",
                                                            type: "collection_look",
                                                            name: "",
                                                            collection: "",
                                                            file: null,
                                                        },
                                                    ],
                                                }))
                                            }
                                        >
                                            <AddIcon/>
                                        </IconButton>


                                        {formData.look.length > 1 && index > 0 && (
                                            <IconButton
                                                color="error"
                                                onClick={() =>
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        look: prev.look.filter(
                                                            (_, i) => i !== index
                                                        ),
                                                    }))
                                                }
                                            >
                                                <RemoveIcon/>
                                            </IconButton>
                                        )}

                                    </Box>
                                </Grid>

                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                <Box sx={{mt: 3}}>
                    <Button
                        type="submit"
                        variant="contained"
                        className='gucci_text'
                    >
                        Save Looks
                    </Button>
                </Box>
            </form>
            <Snackbar
                anchorOrigin={{vertical: state.vertical, horizontal: state.horizontal}}
                open={state.openSuccess}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
            >
                <Alert onClose={handleCloseAlert} severity="success" sx={{width: '300px'}}>
                    {state.successMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{vertical: state.vertical, horizontal: state.horizontal}}
                open={state.openError}
                autoHideDuration={3000}
                onClose={handleCloseAlert}
            >
                <Alert onClose={handleCloseAlert} severity="error" sx={{width: '600px'}}>
                    {state.errorMessage}
                </Alert>
            </Snackbar>
        </>
    )
}
